import { Injectable, signal, computed } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class CommonModalService {

  private readonly _modalHeaderTitleSignal = signal<string | null>(null);
  private readonly _modalHeaderIsCloseBtnVisibleSignal = signal<boolean>(false);
  private readonly _modalHeaderIsSaveBtnVisibleSignal = signal<boolean>(false);
  private readonly _addParticipantModalSignal = signal<any>(false);
  private readonly _editParticipantModalSignal = signal<any>(false);
  private readonly _createGroupModalSignal = signal<boolean>(false);
  private readonly _participantQrModalSignal = signal<boolean>(false);
  private readonly _selfRegQrModalSignal = signal<boolean>(false);

  readonly modalHeaderTitle = computed(() => this._modalHeaderTitleSignal());
  readonly modalHeaderIsCloseBtnVisible = computed(() => this._modalHeaderIsCloseBtnVisibleSignal());
  readonly modalHeaderIsSaveBtnVisible = computed(() => this._modalHeaderIsSaveBtnVisibleSignal());
  readonly addParticipantModalStream = computed(() => this._addParticipantModalSignal());
  readonly editParticipantModalStream = computed(() => this._editParticipantModalSignal());
  readonly createGroupModalStream = computed(() => this._createGroupModalSignal());
  readonly participantQrModalStream = computed(() => this._participantQrModalSignal());
  readonly selfRegQrModalStream = computed(() => this._selfRegQrModalSignal());

  readonly addParticipantModalStream$ = toObservable(this._addParticipantModalSignal);
  readonly editParticipantModalStream$ = toObservable(this._editParticipantModalSignal);
  readonly createGroupModalStream$ = toObservable(this._createGroupModalSignal);
  readonly participantQrModalStream$ = toObservable(this._participantQrModalSignal);
  readonly _selfRegQrModalStream$ = toObservable(this._selfRegQrModalSignal);

  readonly _modalHeaderTitle = {
    next: (value: string) => this._modalHeaderTitleSignal.set(value)
  };
  readonly _modalHeaderIsCloseBtnVisible = {
    next: (value: boolean) => this._modalHeaderIsCloseBtnVisibleSignal.set(value)
  };
  readonly _modalHeaderIsSaveBtnVisible = {
    next: (value: boolean) => this._modalHeaderIsSaveBtnVisibleSignal.set(value)
  };

  updateHeaderTitle(title: string) {
    this._modalHeaderTitleSignal.set(title);
  }

  updateCloseBtnVisiblity(isVisible: boolean) {
    this._modalHeaderIsCloseBtnVisibleSignal.set(isVisible);
  }

  updateSaveBtnVisiblity(isVisible: boolean) {
    this._modalHeaderIsSaveBtnVisibleSignal.set(isVisible);
  }

  triggerAddParticipantModal(data: any) {
    this._addParticipantModalSignal.set(data);
  }

  triggerEditParticipantModal(data: any) {
    this._editParticipantModalSignal.set(data);
  }

  triggerCreateGroupModal(data: boolean) {
    this._createGroupModalSignal.set(data);
  }

  triggerParticipantQrModal(data: boolean) {
    this._participantQrModalSignal.set(data);
  }

  triggerSelfRegistartionModal(data: boolean) {
    this._selfRegQrModalSignal.set(data);
  }
}
